import { gsap, ScrollTrigger, SplitText } from '../global/gsap';

const initLoadIn = (elements) => {
    // set options
    const durationTime = 0.85;
    const easing = 'power4';
    const startPos = 'top 95%';

    const fadeEls = [];
    const charEls = [];

    elements.forEach((element) => {
        if (element.classList.contains('js-char-animate')) {
            const split = new SplitText(element, { type: 'chars' });
            charEls.push([element, split]);
        } else if (element.classList.contains('rich-text')) {
            const subEls = element.querySelectorAll(':scope > *');

            gsap.set(subEls, {
                opacity: 0
            });

            gsap.set(element, {
                opacity: 1
            });

            if (subEls) {
                subEls.forEach((subEl) => {
                    fadeEls.push(subEl);
                });
            }
        } else {
            fadeEls.push(element);
        }
    });

    // Set inital state to avoid flash of content
    gsap.set(fadeEls, {
        opacity: 0
    });

    ScrollTrigger.batch(fadeEls, {
        invalidateOnRefresh: true,
        start: startPos,
        onEnter: (batch) => gsap.to(batch, {
            duration: durationTime,
            opacity: 1,
            stagger: 0.05,
            ease: easing,
            onComplete: () => {
                batch.forEach((batchEl) => {
                    batchEl.classList.add('load-in-complete');
                });
            }
        })
    });

    if (charEls && charEls.length > 0) {
        charEls.forEach((array) => {
            const element = array[0];
            const { chars } = array[1];

            gsap.set(element, {
                opacity: 0
            });

            gsap.set(chars, {
                opacity: 0,
                y: '25%'
            });

            gsap.set(element, {
                opacity: 1
            });

            const animation = gsap.timeline({
                scrollTrigger: {
                    trigger: element,
                    start: 'top bottom'
                }
            });

            animation.to(chars, {
                opacity: 1,
                y: 0,
                duration: 0.5,
                ease: 'power3.out',
                stagger: 0.02
            });
        });
    }
};

export { initLoadIn as default };
